import React from "react";
import { Col, Row } from "react-bootstrap";

export default function Immigration() {
    return (
        <>
            <div className="aboutus_bg">
                <div className="aboutus-img-content">
                    <h1>Immigration & Visa Support Services</h1>
                </div>
            </div>
            <div className="container my-5">
                <div className="row">
                    {/* Main Content Section */}
                    <div className="col-lg-8 vendor-main-content">
                        <img
                            src="images/immig.jpg"
                            alt="Emergency Fund Management"
                            className="img-fluid"
                        />
                        <p>Navigate Canada’s immigration system confidently with expert support for individuals and businesses.</p>
                        <h2 style={{fontWeight:'bold'}}>Our Assistance</h2>
                        <p>
                            <ul>
                                <li><b>Work permit and LMIA applications</b> <br /><br/></li>
                                <li><b>Study and visitor visa support</b> <br /><br/></li>
                                <li><b>Permanent residency applications (Express Entry, PNP)</b> <br /><br/></li>
                                <li><b>Business immigration guidance</b> <br/><br/></li>
                                <li><b>Compliance and document preparation</b></li>
                            </ul>
                        </p>
                        
                    </div>

                    {/* Sidebar Section */}
                    <div className="col-lg-4 vendor-sidebar">
                        {/* Why Choose Us */}
                        <div className="vendor-section vendor-services">
                            <h3 style={{fontWeight:'bold'}}>Benefits</h3>
                            <ul>
                                <li><span class="arrow">➤</span>Reduced application errors 
                                </li>
                                <li><span class="arrow">➤</span>Faster processing</li>
                                <li><span class="arrow">➤</span>Workforce planning support</li>
                                <li><span class="arrow">➤</span>Peace of mind</li>
                            </ul>
                        </div>

                        {/* Latest Posts */}
                        <div className="vendor-section vendor-latest-posts" style={{ marginBottom: '20px' }}>
                            <img
                                src="images/immigv.jpg"
                                alt="Emergency Fund Management"
                                className="img-fluid"
                            />
                            
                        </div>
                        {/* Contact Info */}
                        {/* <div className="vendor-section vendor-contact-info">
                            <h3 style={{fontWeight:'bold'}}>Contact Info</h3>
                            <p>
                                <span> <i class="fa-solid fa-location-dot fa-xl" style={{ color: '#b80404' }}></i> </span>&nbsp;&nbsp;
                                <span>934 McCowan Road, Toronto M1P 3H6</span></p>
                            <p><i class="fa-solid fa-headset fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;+1 (647) 716-1330</p>

                            <p> <i class="fa-solid fa-envelope fa-xl" style={{ color: '#b80404' }}></i>&nbsp;&nbsp;info@rojancanada.com</p>

                        </div> */}
                    </div>
                </div>
            </div >
        </>
    );
}
